export interface OutreachPerson { memberId:number; name:string; }
export interface OutreachHousehold { id:string; name:string; memberIds:number[]; }
export interface OutreachOptions {
 seedMemberIds:number[]; primaryMemberIds:number[]; members:OutreachPerson[]; households:OutreachHousehold[];
}
export interface OutreachSelection {
 seedMemberIds:number[]; memberIds:number[]; members:OutreachPerson[]; ready:boolean;
}
export type OutreachScope='member'|'primary'|'all'|'households'|'custom';
export function outreachIds(options:OutreachOptions,scope:OutreachScope,households:string[],custom:number[]):number[] {
 const allowed=new Set(options.members.map(m=>m.memberId));
 const ids=scope==='member'?options.seedMemberIds:scope==='primary'?[...options.seedMemberIds,...options.primaryMemberIds]:
  scope==='all'?options.members.map(m=>m.memberId):scope==='households'?options.households.filter(h=>households.includes(h.id)).reduce<number[]>((ids,h)=>ids.concat(h.memberIds),[]):custom;
 return [...new Set(ids)].filter(id=>allowed.has(id));
}
